export var DateFields;
(function (DateFields) {
    DateFields["sentAt"] = "sentAt";
    DateFields["deliveredAt"] = "deliveredAt";
    DateFields["createdAt"] = "createdAt";
    DateFields["updatedAt"] = "updatedAt";
    DateFields["expiredAt"] = "expiredAt";
    DateFields["deletedAt"] = "deletedAt";
    DateFields["startsAt"] = "startsAt";
})(DateFields || (DateFields = {}));
//# sourceMappingURL=dates.js.map